module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/item-6-61c1dc1e4bf73eb9341135f382261de1.jpg";